require('./brokerStocksAdvancedSellSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const AdvancedBuySellStockSummary = require('components/broker/commons/advancedBuySellStockSummary/advancedBuySellStockSummary');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER } = require('constants/index');

const BrokerStocksAdvancedSellSuccess = props => {
    const {
        immProductFile,
        immBrokerStocksAdvancedSell,
        immStocksContract,
        immSearchState
    } = props;
    const successMessage = formatText('broker-stocksAdvancedSellSuccessStepMessage');
    const mainButtonLabel = formatText(
        'broker-stocksAdvancedSellSuccessStepBackToWalletButtonLabel'
    );

    return (
        <WizardSuccess
            successMessage={successMessage}
            customClassName="stocks-advanced-sell-success"
            mainButton={{label: mainButtonLabel, url:'/myprofile/broker', modifier: 'secondary'}}
        >
            <div>
                <AdvancedBuySellStockSummary
                    immProductFile={immProductFile}
                    immBrokerStocksAdvancedState={immBrokerStocksAdvancedSell}
                    immStocksContract={immStocksContract}
                    immSearchState={immSearchState}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                />
            </div>
        </WizardSuccess>
    );
};

BrokerStocksAdvancedSellSuccess.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerStocksAdvancedSell: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired
};

module.exports = BrokerStocksAdvancedSellSuccess;
